import { useLoaderData } from 'react-router';
import { gql } from '@/__generated__';
import { preloadQuery } from '@/apollo/apollo-client';
import { fromDatetimeLocal } from '@/date-utils/from-datetime-local';
import { sessionContext } from '@/session';
import { Route } from './+types/route';

const SearchStreamPostsQuery = gql(`
  query SearchStreamPostsQuery($query: String!, $streamId: ID!, $limit: Int!, $offset: Int!, $fromDate: DateTime, $toDate: DateTime) {
    searchStreamPosts(input: {streamId: $streamId, text: $query, limit: $limit, offset: $offset, fromDate: $fromDate, toDate: $toDate}) {
      items {
        ... on StreamPost {
          ...StreamPostCardFragment
        }
      }
    }
  }
  `);

export const streamPostsLoader = async ({
  request,
  params,
  context,
}: Route.ClientLoaderArgs) => {
  if (context.get(sessionContext).kind === 'guest') {
    return {
      q: '',
      from: '',
      to: '',
      hasFilter: false,
      searchStreamPostsQueryRef: null,
    };
  }

  const searchParams = new URL(request.url).searchParams;
  const q = (searchParams.get('q') || '').trim();
  const from = (searchParams.get('from') || '').trim();
  const to = (searchParams.get('to') || '').trim();

  const fromDate = fromDatetimeLocal(from);
  const toDate = fromDatetimeLocal(to);

  const hasFilter = Boolean(q || fromDate || toDate);

  return {
    q,
    from: fromDate ? from : '',
    to: toDate ? to : '',
    hasFilter,
    searchStreamPostsQueryRef: hasFilter
      ? preloadQuery(SearchStreamPostsQuery, {
          variables: {
            streamId: params.id,
            query: q,
            limit: 20,
            offset: 0,
            fromDate,
            toDate,
          },
          fetchPolicy: 'network-only',
        })
      : null,
  };
};

export type StreamPostsLoaderData = Awaited<
  ReturnType<typeof streamPostsLoader>
>;
export const useStreamPostsLoaderData = () =>
  useLoaderData() as StreamPostsLoaderData;
